import React, { useState, useEffect } from 'react';

const HubspotInsertionButton = ({
  listingPhoneSecureValue,
  phoneSecureValue = 0,
  phoneSecureExcludeChat = 0,
  isInsertion,
}) => {
  const [hideHubspotButton, setHideHubspotButton] = useState(null);

  // Check if current page is a support center page
  const currentUrl = window.location.pathname;
  const supportPaths = [
    '/centro-assistenza',
    '/support-center',
    '/centro-de-asistencia',
  ];
  const isSupportPage = supportPaths.some((path) => currentUrl.includes(path));

  function toggleHubspotChat() {
    var chatWidget = document.getElementById('hubspot-chat-widget');
    var livechatWindow = document.getElementById('livechat-window');

    chatWidget.classList.toggle('display');
    livechatWindow.classList.remove('hidden');
    livechatWindow.classList.toggle('is-opened');

    if (chatWidget.classList.contains('display')) {
      if (
        window.HubSpotConversations &&
        window.HubSpotConversations.widget &&
        typeof window.HubSpotConversations.widget.load === 'function'
      ) {
        window.HubSpotConversations.widget.load({ widgetOpen: true });
      }

      // Track chat opened event
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('Chat Opened');
      }
    }

    hideHubspotUnreadBadge();
  }

  function hideHubspotUnreadBadge() {
    localStorage.setItem('shouldRenderHubspotUnreadBadge', 0);
    document.getElementById('hubspot-unread-badge').classList.add('hidden');
  }

  const hubspotLink = (
    <div
      id="livechat-window"
      onClick={() => toggleHubspotChat()}
      className={`${isInsertion === 'true' ? 'insertion-footer' : ''} ${
        isSupportPage ? 'hidden' : ''
      }`.trim()}
    >
      <div
        id="hubspot-chat-button"
        role="button"
        className={
          Number(phoneSecureValue) >= Number(listingPhoneSecureValue)
            ? 'right-position'
            : ''
        }
      >
        <span id="hubspot-unread-badge" className="hidden"></span>
        <span
          className="iconify icon-expand"
          data-icon="bi:chat-left-dots"
        ></span>
        {/* Shown via CSS only in the expanded pill variant (test cohort of
            the ab-phone-button experiment). "Chat" is locale-invariant across
            it/en/es, hence no WPML string. */}
        <span className="chat-button-label">Chat</span>
        <span className="iconify icon-contract" data-icon="ep:close"></span>
      </div>
    </div>
  );

  useEffect(() => {
    const fetchAvailability = async () => {
      try {
        setHideHubspotButton(
          (listingPhoneSecureValue &&
            Number(phoneSecureExcludeChat) &&
            Number(phoneSecureValue) >= Number(listingPhoneSecureValue)) ||
            (!listingPhoneSecureValue && Number(phoneSecureExcludeChat))
        );
      } catch (error) {
        // console.error(error);
        setHideHubspotButton(false);
      }
    };

    fetchAvailability();
  }, []);

  if (hideHubspotButton === null || hideHubspotButton) {
    return null;
  }
  return hubspotLink;
};

export { HubspotInsertionButton };
